<template>
  <div class="boxcontent-item" @click="$emit('select', category.id)">
    <i class="far fa-folder-open"></i>
    <p class="boxcontent-item-title">{{category.name}}</p>
  </div>
</template>

<script>
export default {
  props: {
    category: Object
  }
};
</script>